// extracted by mini-css-extract-plugin
export default {"customerButton":"index_customerButton__77-MU"};